<template>
  <!-- 验收 -->
  <div class="pre">
    <div class="mkssfj">
      <div class="title">
        <div class="t">
          所属模块附件
          <div class="f">
            <el-form ref="form" :model="form1" label-width="100px">
              <el-form-item label="状态">
                <el-select
                  clearable
                  v-model="ct_status"
                  placeholder="请选择状态"
                  :disabled="!userInfo.director"
                  @change="_setCt_status"
                >
                  <el-option
                    v-for="item in tboptions.status"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <!-- <div class="tool">
        <file
          ref="choos1"
          :choos="choos1"
          ty="0"
          @GetFile="_GetFile()"
          @showList="showList('0')"
          :par="true"
        />
      </div> 
      @dblclick="showList('0')"-->
      <el-row :gutter="10">
        <el-col
          :xs="12"
          :sm="12"
          :lg="12"
          v-for="(item, idx) in data1"
          :key="idx"
        >
          <div
            class="pobox"
            :class="{ isactive: choos1.id == item.id }"
            @click="handClick(item)"
          >
            <img :src="item.ico" :alt="item.name" />
            <div class="name">{{ item.name }}({{ item.num }})</div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="tymb">
      <div class="title">
        <div class="t">通用模板</div>
      </div>
      <!-- <div class="tool">
        <file
          ref="choos2"
          :choos="choos2"
          ty="1"
          @GetFile="_GetFile()"
          @showList="showList('1')"
          :par="true"
        />
      </div>  @dblclick="showList('1')"-->

      <el-row :gutter="10">
        <el-col
          :xs="4"
          :sm="4"
          :lg="{ span: '4-8' }"
          v-for="(item, idx) in data2"
          :key="idx"
        >
          <div
            class="pobox"
            :class="{ isactive: choos2.id == item.id }"
            @click="handClick2(item)"
          >
            <div class="name">{{ item.name }}({{ item.num }})</div>
            <img :src="item.ico" :alt="item.name" />
          </div>
        </el-col>
      </el-row>
    </div>
    <filelist
      ref="filelist"
      :ty="ty"
      :choos="ty == '0' ? choos1 : choos2"
      @GetFile="_GetFile()"
    />
  </div>
</template>

<script>
// import file from '@components/file.vue'
import filelist from '@components/filelist.vue'
import { GetFile, Query_tsys_dicvalue, setCt_status } from '@api/api.js'
export default {
  components: {
    // file,
    filelist
  },
  data() {
    return {
      userInfo: JSON.parse(sessionStorage.userInfo) || {}, // 用户登录信息
      name: this.$route.query.name,
      autoid: this.$route.query.autoid,
      activeTool: '', // 选中的工具
      choos1: { id: 0 },
      choos2: { id: 0 },
      data1: [
        {
          name: '项目验收报告',
          ico: require('@/assets/img/pic_ys_01.png'),
          num: 0,
          id: 1
        },
        {
          name: '培训视频',
          ico: require('@/assets/img/pic_ys_02.png'),
          num: 0,
          id: 2
        }
      ],
      data2: [
        {
          name: '项目验收报告',
          ico: require('@/assets/img/pic_zb_05.png'),
          num: 0,
          id: 1
        },
        {
          name: '培训视频',
          ico: require('@/assets/img/pic_zb_05.png'),
          num: 0,
          id: 2
        }
      ],
      file: [],
      ty: '0',
      ct_status: '',
      tboptions: {
        status: []
      }
    }
  },
  created() {
    this._GetFile()
    this._Query_tsys_dicvalue()
  },
  //监听路由变化
  watch: {
    '$route.query': {
      handler(newVal, oldVal) {
        //判断newVal有没有值监听路由变化
        this.name = newVal.name
        this.autoid = newVal.autoid
        this._GetFile()
      },
      deep: true
    }
  },
  methods: {
    _setCt_status() {
      setCt_status({ autoid: this.autoid, ct_status: this.ct_status }).then(
        res => {
          this.$message.success('修改成功')
          this._GetFile() // 获取列表
        }
      )
    },
    _Query_tsys_dicvalue() {
      Query_tsys_dicvalue({ mautoid: '4' }).then(res => {
        this.tboptions.status = res.list.map(e => {
          return {
            value: e.dicvalue,
            label: e.dicvalue
          }
        })
      })
    },
    _GetFile() {
      GetFile({
        autoid: this.autoid,
        packagetype: ['项目验收报告', '培训视频'].join(',')
      }).then(res => {
        this.ct_status = res.data[0].ct_status
        this.data1.forEach(e => {
          e.num = 0
        })
        this.data2.forEach(e => {
          e.num = 0
        })
        this.file = res.list
        res.list.forEach(e => {
          let array = e.ty == '0' ? this.data1 : this.data2
          for (let index = 0; index < array.length; index++) {
            let element = array[index]
            if (element.name == e.packagetype) {
              element.num++
              break
            }
          }
        })
      })
    },

    handClick(item) {
      this.choos1 = item
      this.showList('0')
    },
    handClick2(item) {
      this.choos2 = item
      this.showList('1')
    },
    showList(ty) {
      this.ty = ty
      let element = ty == '1' ? this.choos2 : this.choos1
      // let f = this.file.filter(e => {
      //   return e.ty == ty && element.name == e.packagetype
      // })
      // if (f.length == 0) {
      //   this.$message.warning('当前选择的类型没有附件！')
      // } else {
      //   this.$refs.filelist.show = true
      // }

      this.$refs.filelist.show = true
    }
  }
}
</script>

<style scoped lang="scss">
.pre {
  .mkssfj,
  .tymb {
    background: #fff;
    border-radius: 0px 6px 6px 0px;
    .title {
      padding: 10px 0;
      margin: 0 20px;
      height: 60px;
      border-bottom: 1px solid #e5e5e5;
      display: flex;
      align-items: center;
      font-size: 22px;
      font-family: Microsoft YaHei;
      font-weight: bold;
    }
    .title::before {
      content: '';
      width: 5px;
      height: 20px;
      background: rgba(0, 127, 245, 1);
      margin-right: 10px;
    }
    .t {
      width: calc(100% - 10px);

      display: flex;
      align-items: center;
      justify-content: space-between;
      .f {
        height: 60px;
        padding-top: 10px;
      }
    }
    .tool {
      margin: 10px 0;
      display: flex;
      height: 70px;
      align-items: center;
      .el-button--default {
        color: var(--formFontcolor);
      }
    }
    .el-row {
      padding: 10px;
      .isactive {
        border: 1px solid rgba(0, 127, 245, 1);
      }
      .el-col-lg-4-8 {
        width: 20%;
      }
    }
  }
  .mkssfj {
    margin-bottom: 10px;
    .pobox {
      cursor: pointer;
      background: #ffffff;
      box-shadow: 3px 1px 10px 0px rgba(114, 113, 113, 0.26);
      border-radius: 10px;
      border: 1px solid transparent;
      img {
        width: 100%;
      }
      .name {
        line-height: 60px;
        font-size: 20px;
        font-family: Alibaba PuHuiTi 2;
        font-weight: normal;
        color: #131521;
        text-align: center;
      }
    }
    .pobox.isactive {
      border: 1px solid #0082f5;
    }
  }
  .tymb {
    .pobox {
      cursor: pointer;
      height: 153px;
      background: #f3f5f6;
      border-radius: 10px;
      border: 1px solid transparent;
      display: flex;
      justify-content: space-around;
      align-items: center;
      img {
        height: 100px;
      }
      .name {
        font-size: 20px;
        font-family: Alibaba PuHuiTi 2;
        font-weight: normal;
        color: #131521;
      }
    }
    .pobox.isactive {
      border: 1px solid #0082f5;
    }
  }
}
</style>
